import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthTokenService } from '@core/services/auth-token.service';

export const authGuard: CanActivateFn = () => {
  const tokens = inject(AuthTokenService);
  if (tokens.isAuthenticated()) {
    return true;
  }

  const router = inject(Router);
  return router.createUrlTree(['/login']);
};
